import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import shadenet_blog_img from "../../Assets/shadenet_blog_img.png";
import "animate.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";

import "./blog.css";

function Net_House_Farming() {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container fluid>
      <div className="d-flex justify-content-center">
        <img
          src={shadenet_blog_img}
          className={`card-img-top img-fluid p-3 rounded animate__animated animate__fadeInDown ${
            showImage ? "show" : ""
          }`}
          style={{ width: "90%" }}
          alt="shade net house"
        />
      </div>
      <Row className="m-3">
        <Col className="p-4 textJustify" sm={12} md={10} lg={8} id="content">
          <div id="blog1" className="border p-2">
            <h1 className="text-center p-3">Net House Farming</h1>
            <p>
              At{" "}
              <span className="fw-bold">
                Royal Green House Construction (I) Pvt. Ltd. (RGCPL)
              </span>
              , we are transforming Indian agriculture with innovative,
              sustainable solutions tailored to modern farming needs. Among our
              most in-demand offerings is{" "}
              <span className="fw-bold">Net House Farming</span>—a
              cost-effective, eco-conscious cultivation technique that improves
              crop protection, increases yields, and enables off-season
              production.
            </p>
            <p>
              In this blog, explore what Net House Farming is, its key benefits,
              ideal crops, and why RGCPL is your most reliable partner for
              implementing this next-gen agricultural practice.
            </p>
            <h2 className="pt-3">What is Net House Farming?</h2>
            <p>
              Net House Farming is a type of protected cultivation that involves
              growing crops under a framed structure covered with HDPE
              (High-Density Polyethylene) shade nets. These nets manage
              sunlight, temperature, humidity, and air movement while protecting
              crops from pests, insects, and harsh weather conditions.
            </p>
            <p>
              Compared to traditional farming, Net House Farming offers a
              semi-controlled environment, making it ideal for vegetables,
              fruits, nursery plants, and even{" "}
              <a href="https://royalgreenhouse.co.in/Floriculture">
                ornamental flowers
              </a>
              . It minimizes pesticide usage and ensures uniform, high-quality
              crop production.
            </p>
            <p>
              If you’re interested in a complete protected farming solution,
              explore our specialized hydroponic farming setups designed to work
              alongside Net House structures.
            </p>

            <h2 className="pt-3">Types of Net Houses We Offer</h2>
            <p>
              At <a href="https://royalgreenhouse.co.in/">RGCPL</a>, we offer a
              variety of Net House structures to suit different crop needs and
              climatic conditions.
            </p>
            <ol>
              <li>
                <span className="fw-bold">Low-Cost Net House</span>
                <ul>
                  <li>Made using lightweight and budget-friendly GI pipes</li>
                  <li>Offers effective pest, bird, and sunlight protection</li>
                  <li>Low maintenance and excellent ventilation</li>
                  <li>
                    Ideal for vegetables, nurseries, and shade-loving crops
                  </li>
                </ul>
              </li>
              <li>
                <span className="fw-bold">
                  <a href="https://royalgreenhouse.co.in/flat-shade-net-house">
                    Flat Shade Net House
                  </a>
                </span>
                <ul>
                  <li>Flat-roofed structure using GI/steel pipes</li>
                  <li>
                    Designed for areas with low rainfall and moderate wind
                  </li>
                  <li>Uses UV-stabilized nets for enhanced durability</li>
                  <li>Fully customizable in size and configuration</li>
                </ul>
              </li>
              <li>
                <span className="fw-bold">
                  <a href="https://royalgreenhouse.co.in/tunnel-shade-net-house">
                    Tunnel Shade Net House
                  </a>
                </span>
                <ul>
                  <li>Curved or arched structure with heavy-duty GI pipes</li>
                  <li>
                    Features optional drip irrigation & roll-up side walls
                  </li>
                  <li>Ensures good air circulation and uniform crop growth</li>
                  <li>Best for vegetables, fruits, and ornamental plants</li>
                </ul>
              </li>
            </ol>

            <h2 className="pt-3">Why Choose RGCPL for Net House Farming?</h2>
            <p>
              With over 15 years of experience in protected cultivation, RGCPL
              is one of India’s leading Net House Farming solution providers.
            </p>
            <ul>
              We provide:
              <li>
                <span className="fw-bold">Complete services</span> – from
                consultation to installation
              </li>
              <li>
                <span className="fw-bold">Custom-built structures</span> – based
                on crop, soil, and climate
              </li>
              <li>
                <span className="fw-bold">High-quality materials</span> – GI
                pipes, UV-treated nets, and irrigation
              </li>
              <li>
                <span className="fw-bold">Post-installation support</span> –
                including crop care and maintenance training
              </li>
              You can browse some of our successful installations in the{" "}
              <a href="https://royalgreenhouse.co.in/gallery">
                projects section
              </a>{" "}
              to see the difference we’ve made for farmers across India.
            </ul>
            <h2 className="pt-3">Benefits of Net House Farming</h2>
            <p>
              Implementing Net House Farming comes with multiple advantages for
              farmers:
            </p>
            <ul>
              <li>
                <span className="fw-bold">Pest & Disease Control:</span> Reduces
                reliance on chemical pesticides
              </li>
              <li>
                <span className="fw-bold"> Efficient Irrigation:</span> Supports
                drip and fertigation systems
              </li>
              <li>
                <span className="fw-bold">UV Protection:</span> Shade nets
                filter harmful radiation
              </li>
              <li>
                <span className="fw-bold">Eco-Friendly :</span> Promotes organic
                and sustainable practices
              </li>
              <li>
                <span className="fw-bold">Year-Round Production :</span> Enables
                off-season farming and multiple harvests
              </li>
              <li>
                <span className="fw-bold">Higher Yields:</span> Better crop
                quality and quantity
              </li>
            </ul>
            <h2 className="pt-3">Ideal Crops for Net House Farming</h2>
            <p>
              Net House Farming is highly versatile and supports a wide range of
              crops:
            </p>
            <ul>
              <li>
                <span className="fw-bold">Vegetables:</span> Tomato, capsicum,
                cucumber, chili
              </li>
              <li>
                <span className="fw-bold">Fruits:</span> Strawberry, papaya,
                melon
              </li>
              <li>
                <span className="fw-bold">Flowers:</span> Marigold, rose,
                carnation, gerbera
              </li>
              <li>
                <span className="fw-bold">Nursery Plants:</span> Saplings,
                ornamentals, and medicinal plants
              </li>
              This setup is especially beneficial for{" "}
              <a href="https://royalgreenhouse.co.in/commercial-hydroponic-farming">
                commercial hydroponic farming
              </a>{" "}
              as it provides the microclimate control needed for precision
              agriculture.
            </ul>
            <h2 className="pt-3">
              Government Subsidy Support – National Horticulture Board (NHB)
            </h2>
            <p>
              At RGCPL, we help farmers access government subsidies for Net
              House Farming under the National Horticulture Board (NHB) scheme.
            </p>
            <p>
              Our team provides end-to-end support:
              <ul>
                <li> Eligibility verification</li>
                <li>Documentation assistance</li>
                <li>Complete application processing</li>
                <li>Follow-up and approval guidance</li>
                We ensure a smooth, stress-free experience so you can focus on
                your crops.
              </ul>
            </p>

            <p>
              <span className="fw-bold">Net</span> House Farming is more than a
              technique—it’s a sustainable path to higher productivity and
              income. With RGCPL’s proven expertise, customized designs, and
              start-to-finish support, you're investing in a smarter, greener,
              and more resilient agricultural future.
            </p>
            <p>
              <i>Get Started with RGCPL Today</i>
            </p>
            <p>
              Ready to revolutionize your farm with Net House Farming? Contact
              Royal Green House Construction (I) Pvt. Ltd. today to get expert
              guidance, a tailored proposal, and unmatched support in protected
              farming solutions.
            </p>
            <div className="d-flex justify-content-center mt-4">
              <Link to="/RequestAQuote">
                <Button variant="success" size="lg">
                  Get a Free Quote Now!
                </Button>
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Net_House_Farming;
